import { jsxs, jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../../foundations/icons/Icon.js";
import { s as styles } from "../../../../chunks/Toggletip.module-D9Zn2F9e.js";
const ToggletipIcon = ({ isActive, variant }) => {
  const size = 16;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: clsx(
        styles.toggletipIcon,
        styles[`toggletip-${variant}-icon`],
        isActive && styles[`toggletip-${variant}-active`]
      ),
      children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            variant: "Info",
            className: clsx(isActive && styles.toggletipIconHidden),
            "aria-hidden": "true",
            width: size,
            height: size
          }
        ),
        /* @__PURE__ */ jsx(
          Icon,
          {
            variant: "InfoFilled",
            className: clsx(!isActive && styles.toggletipIconHidden),
            "aria-hidden": "true",
            width: size,
            height: size
          }
        )
      ]
    }
  );
};
export {
  ToggletipIcon
};
